/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const propTypes = {
  chats: PropTypes.array.isRequired,
};

const ChatList = ({ chats }) => (
  <Container>
    <Header>
      <FormattedMessage
        id="chat.title"
        description="Label for chat list title"
        defaultMessage="Conversations with reviewers"
      />
    </Header>

    <List>
      {chats && chats.length ? (
        chats.map(({ id, name }) => (
          <li key={id}>
            <Link to={`/selvitys/chat/${id}`}>
              <FormattedMessage
                id="chat.conversation"
                description="Label for conversations"
                defaultMessage="Conversation #{id} - {name}"
                values={{ id, name }}
              />
            </Link>
          </li>
        ))
      ) : (
        <li>
          <FormattedMessage
            id="chat.noConversations"
            description="Label for no conversations"
            defaultMessage="No conversations"
          />
        </li>
      )}
    </List>
  </Container>
);

ChatList.propTypes = propTypes;

const Container = styled.div`
  background-color: #fffff;
  box-shadow: 0 1px 25px 3px ${props => props.theme['grey-normal']};
  margin: 16px;
`;

const Header = styled.div`
  font-weight: bold;
  border-bottom: 1px solid ${props => props.theme['grey-normal']};
  padding: 12px;
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 12px;
`;

export default ChatList;
